<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            name="txtNaziv"
                            formControlName="Naziv"
                            [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                            [Label]="'FIRMA.NAZIV.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                            <span *ngFor="let validation of errorMessages.Naziv">
                              <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                        </div>                    
                    </div>
                </div>
            <!-- </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-12"> -->
                <!-- <div class="form-group row">
                    <div class="col-12">
                        <yt-dropdown-picklist
                            [ModelName]="'tipkomitenta'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="false"
                            [Label]="'FIRMA.TIPKOMITENTA.SINGULAR'"
                            formControlName="TipKomitentaID"
                            (OnItemSelected)="OnTipKomitentaSelected($event)">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message"
                              *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid"><span
                                translate="{{this.baseFormGroup.errors.checkControls.message}}"></span></span>
                          </div>
                        <div class="form-error" *ngIf="submitted && fc.TipKomitentaID.invalid">
                            <span *ngFor="let validation of errorMessages.TipKomitentaID">
                              <span class="error-message" *ngIf="fc.TipKomitentaID.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div> -->
            <!-- </div>
        </div> -->
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-input
                            [Type]="'text'"
                            formControlName="Pib"
                            [Label]="'COMPANY.PIB-JMBG.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
                            <span *ngFor="let validation of errorMessages.Pib">
                              <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-input
                            [Type]="'text'"
                            formControlName="MaticniBroj"
                            [Label]="'COMPANY.MATICNIBROJ-BROJ-PG.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.MaticniBroj.invalid">
                            <span *ngFor="let validation of errorMessages.MaticniBroj">
                              <span class="error-message" *ngIf="fc.MaticniBroj.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="row">
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'FIRMA.JMBG.SINGULAR'"
                            formControlName="Jmbg">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Jmbg.invalid">
                            <span *ngFor="let validation of errorMessages.Jmbg">
                              <span class="error-message" *ngIf="fc.Jmbg.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'FIRMA.BROJGAZDINSTVA.SINGULAR'"
                            formControlName="BrojPoljoprivrednogGazdinstva">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.BrojPoljoprivrednogGazdinstva.invalid">
                            <span *ngFor="let validation of errorMessages.BrojPoljoprivrednogGazdinstva">
                              <span class="error-message" *ngIf="fc.BrojPoljoprivrednogGazdinstva.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-input
                            [Type]="'text'"
                            formControlName="Adresa"
                            [Label]="'COMPANY.ADRESA.SINGULAR'"
                            [ngClass]="{'is-invalid': submitted && fc.Adresa.invalid}">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
                            <span *ngFor="let validation of errorMessages.Adresa">
                              <span class="error-message" *ngIf="fc.Adresa.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-12">
                        <yt-autocomplete
                            [ModelName]="'mesto'"
                            [GetName]="'getByNaziv'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [Label]="'COMPANY.MESTO.SINGULAR'"
                            formControlName="MestoID"
                            [ngClass]="{'is-invalid': submitted && fc.MestoID.invalid}">
                        </yt-autocomplete>
                        <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
                            <span *ngFor="let validation of errorMessages.MestoID">
                              <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>